import React from 'react';
import { arrayOf, bool, func, number } from 'prop-types';
import { creditType, instanceType } from 'types';

import { get } from 'lodash';
import moment from 'moment';

import FormWrapper from 'components/FormWrapper';
import Message from 'components/Message';

import { NOW } from 'utils/constants';
import InnerForm from './innerForm';
import { matchingId } from '../../utils/filters';

const CreditActivationForm = ({
  creditId,
  credits,
  showCreditsDropdown,
  showInstancesDropdown,
  hideModal,
  instanceId,
  instances,
  onSubmit
}) => {
  // Pre-select Credit if there is only one
  const selectedCreditId =
    creditId || (credits.length === 1 ? credits[0].id : undefined);
  const selectedCredit = credits.find(({ id }) => id === selectedCreditId);

  const creditGroup = selectedCredit?.group;

  const filteredInstances = instanceId
    ? instances.filter(({ id }) => id === instanceId)
    : instances
        .filter(
          (instance) =>
            !instance.project_instance_data?.plan.is_contract &&
            !instance.suspended
        )
        .filter(({ groups }) =>
          creditGroup ? groups.find(matchingId(creditGroup)) : true
        );

  if (
    (showCreditsDropdown && !instanceId) ||
    (showInstancesDropdown && !creditId)
  ) {
    return (
      <Message type={Message.types.ERROR} withMarginBottom>
        Something went wrong! We can’t activate the credit at this time.
      </Message>
    );
  }

  // Pre-select FlexBox if there is only one
  const selectedInstance =
    filteredInstances.length === 1 ? filteredInstances[0].id : undefined;

  // If we are activating a credit, we display the credit name
  const credit = credits.find((c) => c.id === creditId);
  const creditName = get(credit, ['credit_type', 'name']);

  // If we are adding a credit to an instance, we display the instance name
  const instance = filteredInstances.find((c) => c.id === instanceId);
  const instanceName = get(instance, ['alias']);

  const formName = creditId
    ? `Activate ${creditName} Credit`
    : `Apply Credit to ${instanceName}`;

  // We set the minimum start time for a credit to the current minute;
  // this means that leaving the modal open, it is possible to start a
  // credit in the past. This could be amended to update using setTimeout,
  // but that has its own issues.
  const minDateTime = new Date(moment().startOf('m'));

  const initialValues = {
    activation: NOW,
    creditId: selectedCreditId,
    creditScheduleDate: undefined,
    instanceId: instanceId || selectedInstance
  };

  return (
    <FormWrapper
      data-testId="formWrapper"
      formName={formName}
      handleSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={InnerForm.validationSchema}
    >
      <InnerForm
        credits={credits}
        showCreditsDropdown={showCreditsDropdown}
        showInstancesDropdown={showInstancesDropdown}
        instances={filteredInstances}
        hideModal={hideModal}
        minDate={minDateTime}
        group={creditGroup}
      />
    </FormWrapper>
  );
};

CreditActivationForm.propTypes = {
  creditId: number,
  credits: arrayOf(creditType).isRequired,
  showCreditsDropdown: bool,
  showInstancesDropdown: bool,
  hideModal: func.isRequired,
  instanceId: number,
  instances: arrayOf(instanceType).isRequired,
  onSubmit: func.isRequired
};

export default CreditActivationForm;
